export default __webpack_public_path__ + "static/media/842 - CPyrc-II.565ef0a3.jpeg";